import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';

export const DiscountsLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('discounts.title'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'discounts',
                label: t('discounts.title'),
                url: ROUTES.discounts.list,
                isActive: path === ROUTES.discounts.list,
              },
              {
                key: 'discounts-usage',
                label: t('alternatives.reports.title'),
                url: ROUTES.discounts.usage,
                isActive: path === ROUTES.discounts.usage,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
